import { render, staticRenderFns } from "./live-card.vue?vue&type=template&id=642aac9a&scoped=true&"
import script from "./live-card.vue?vue&type=script&lang=js&"
export * from "./live-card.vue?vue&type=script&lang=js&"
import style0 from "./live-card.vue?vue&type=style&index=0&id=642aac9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642aac9a",
  null
  
)

/* custom blocks */
import block0 from "./live-card.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports